export enum EGeneralIds {
  OPENING_HOURS = 'opening-hours',
  HOLIDAYS_AND_RECESSES = 'holiday-and-recess',
  SPACES = 'spaces',
  ACTIVITIES = 'activities',
  CULTURE = 'culture',
  CUSTOMERS_AND_VISITORS = 'general-information',
  OPERATION_CAPACITY = 'operation-capacity',
  PRINTERS = 'printer',
  RECEIPTS = 'receipts',
  MIGRATOR = 'migrator',
  CATEGORIES = 'categories',
  AVERAGE_TICKET = 'average-ticket',
  RESTORE_DEFAULTS = 'restore-defaults',
}

export const generalPageFragments = [
  {
    title: 'SETTINGS.GENERAL.OPENING_HOURS.OPENING_HOURS',
    id: EGeneralIds.OPENING_HOURS,
  },
  {
    title: 'SETTINGS.GENERAL.HOLIDAYS_AND_RECESSES.HOLIDAYS_AND_RECESSES',
    id: EGeneralIds.HOLIDAYS_AND_RECESSES,
  },
  {
    title: 'SETTINGS.GENERAL.SPACES.SPACES',
    id: EGeneralIds.SPACES,
  },
  {
    title: 'SETTINGS.GENERAL.ACTIVITIES.ACTIVITIES',
    id: EGeneralIds.ACTIVITIES,
  },
  {
    title: 'SETTINGS.GENERAL.CULTURE.CULTURE',
    id: EGeneralIds.CULTURE,
  },
  {
    title: 'SETTINGS.GENERAL.CUSTOMERS_AND_VISITORS.CUSTOMERS_AND_VISITORS',
    id: EGeneralIds.CUSTOMERS_AND_VISITORS,
  },
  {
    title: 'SETTINGS.GENERAL.OPERATION_CAPACITY.TITLE',
    id: EGeneralIds.OPERATION_CAPACITY,
  },
  {
    title: 'SETTINGS.GENERAL.PRINTERS.PRINTERS',
    id: EGeneralIds.PRINTERS,
  },
  {
    title: 'SETTINGS.GENERAL.RECEIPTS.RECEIPTS',
    id: EGeneralIds.RECEIPTS
  },
  {
    title: 'SETTINGS.GENERAL.MIGRATOR.MIGRATOR',
    id: EGeneralIds.MIGRATOR
  },
  {
    title: 'SETTINGS.GENERAL.CATEGORIES.CATEGORIES',
    id: EGeneralIds.CATEGORIES
  },
  {
    title: 'SETTINGS.GENERAL.AVERAGE_TICKET.TITLE',
    id: EGeneralIds.AVERAGE_TICKET
  },
  {
    title: 'SETTINGS.GENERAL.RESTORE_DEFAULTS.RESTORE_DEFAULTS',
    id: EGeneralIds.RESTORE_DEFAULTS
  }
];
